<template>
  <div>
    <el-card class="box-card">
      <el-form ref="searchParam" :model="searchParam" label-width="80px">
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="科目类型" label-width="80px" prop="ppid">
              <el-select
                v-model="searchParam.ppid"
                placeholder="请选择"
                clearable
                @change="choosePPid()"
              >
                <el-option
                  v-for="item in ppList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="所属科目" label-width="80px" prop="pid">
              <el-select v-model="searchParam.pid" placeholder="请选择" clearable>
                <el-option v-for="item in pList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="具体课程" label-width="80px" prop="name">
              <el-input v-model="searchParam.name" placeholder="请输入课程名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item>
              <el-button type="primary" @click="searchList()">查询</el-button>
              <el-button @click="resetForm('searchParam')">清空已选</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="box-card" style="margin-top: 20px;">
      <el-row>
        <el-col :span="12">
          <el-button type="primary" icon="el-icon-plus" @click="addFormVisible = true">添加具体课程</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-table :data="list" border style="width: 100%;margin-top:20px">
          <el-table-column type="index" label="序号" width="100"></el-table-column>
          <el-table-column prop="ppname" label="科目类型" width="300"></el-table-column>
          <el-table-column prop="pname" label="科目" width="300"></el-table-column>
          <el-table-column prop="name" label="具体课程" width="300"></el-table-column>
          <el-table-column prop="number" label="类型编号"></el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
          <el-table-column label="状态" width="100" prop="state">
            <template slot-scope="scope">
              <el-switch
                @change="changeState(scope.row)"
                v-model="scope.row.state==1"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </template>

            <!-- <template slot-scope="scope">{{scope.row.state==1?'启用':'禁用'}}</template> -->
          </el-table-column>
          <el-table-column prop="course" fixed="right" label="操作" width="100">
            <template slot-scope="scopeBtn">
              <el-button type="text" size="small" @click="editBtn(scopeBtn.row.id)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>

      <el-pagination
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px;text-align: right;"
        :total="returnVal.total"
        :page-size="returnVal.size"
        :current-page="returnVal.current"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>
    <!------------------------------------------ 添加 ------------------------------------------->
    <el-dialog title="添加具体课程" :visible.sync="addFormVisible" width="500px">
      <el-form ref="addForm" :model="addForm" label-width="80px" :rules="addRules">
        <el-form-item label="科目类型" label-width="80px" prop="ppid">
          <el-select
            v-model="addForm.ppid"
            placeholder="请选择"
            @change="chooseAddPPid(addForm.ppid,false)"
          >
            <el-option v-for="item in ppList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属科目" label-width="80px" prop="pid">
          <el-select v-model="addForm.pid" placeholder="请选择" clearable>
            <el-option v-for="item in addpList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程名称" prop="name">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="类型编号" prop="number">
          <el-input v-model.number="addForm.number"></el-input>
        </el-form-item>
        <el-form-item label="显示排序" prop="sort" v-model="addForm.sort">
          <el-input v-model.number="addForm.sort"></el-input>
        </el-form-item>
        <el-form-item label="备注说明" prop="remark">
          <el-input v-model="addForm.remark" type="textarea" auto-complete="off" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="state">
          <el-switch v-model="addForm.state" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="resetForm('addForm')">重 置</el-button>
        <el-button type="primary" @click="submitAdd">确 定</el-button>
      </div>
    </el-dialog>

    <!------------------------------------------ 编辑 ------------------------------------------->
    <el-dialog title="编辑具体课程" :visible.sync="editFormVisible" width="500px">
      <el-form ref="editForm" :model="editForm" label-width="80px" :rules="addRules">
        <el-form-item
          label="科目类型"
          label-width="80px"
          prop="ppid"
          @change="chooseAddPPid(editForm.ppid,false)"
        >
          <el-select v-model="editForm.ppid" placeholder="请选择">
            <el-option v-for="item in ppList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科目名称" label-width="80px" prop="pid">
          <el-select v-model="editForm.pid" placeholder="请选择">
            <el-option v-for="item in addpList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程名称" prop="name">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="课程编号" prop="number">
          <el-input v-model.number="editForm.number" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="显示排序" prop="sort" v-model="editForm.sort">
          <el-input v-model.number="editForm.sort" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="备注说明" prop="remark">
          <el-input v-model="editForm.remark" type="textarea" auto-complete="off" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="state">
          <el-switch
            :disabled="true"
            v-model="editForm.state==1"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button type="primary" @click="submitEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      addpList: [], //二级列表（弹窗）
      list: [], //三级列表
      pList: [], //二级列表
      ppList: [], //一级列表
      returnVal: {},
      editForm: {},
      editParam: {},
      label: "1",
      editFormVisible: false,
      addFormVisible: false,
      typeParam: {
        name: "",
        level: 0,
        state: 1,
        pageSize: 10,
        pageNumber: 1
      },
      //searchparam跟param不能共用，填写searchParam，但不搜索，getlist时param=searchParam，列表参数不对
      //搜索条件
      searchParam: {
        name: "",
        level: 2,
        ppid: "",
        pid: "",
        pageSize: 10,
        pageNumber: 1
      },
      //三级列表参数
      param: {
        name: "",
        level: 2,
        ppid: "",
        pid: "",
        pageSize: 10,
        pageNumber: 1
      },
      addForm: {
        level: 2,
        ppid: "",
        pid: "",
        name: "",
        number: "",
        sort: "",
        remark: "",
        state: true
      },
      addRules: {
        ppid: [
          { required: true, message: "请选择科目类型", trigger: "change" }
        ],
        pid: [{ required: true, message: "请选择所属科目", trigger: "change" }],
        name: [{ required: true, message: "请输入科目名称", trigger: "blur" }],
        number: [
          { required: true, message: "请输入类型编号", trigger: "blur" },
          { type: "number", message: "类型编号必须为数字" }
        ],
        sort: [
          { required: true, message: "请输入显示排序", trigger: "blur" },
          { type: "number", message: "显示排序必须为数字" }
        ]
      }
    };
  },
  methods: {
    currentChange(pageNumber) {
      this.param.pageNumber = pageNumber;
      this.getList();
    },
    changeState(e) {
      console.log(e);
      if (e.state == 1) {
        this.$confirm(
          "禁用此科目类型会把下属的科目和课程全部禁用,是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            this.api.subjectCourse
              .offSubjectCourse({
                id: e.id
              })
              .then(result => {
                if (result.code == 200) {
                  this.$message({
                    message: result.message,
                    type: "success"
                  });
                  this.getList();
                } else {
                  this.$message.error(result.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消"
            });
          });
      } else {
        this.$confirm(
          "开启此科目类型会把下属的科目和课程全部开启,是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            this.api.subjectCourse
              .onSubjectCourse({
                id: e.id
              })
              .then(result => {
                if (result.code == 200) {
                  this.$message({
                    message: result.message,
                    type: "success"
                  });
                  this.getList();
                } else {
                  this.$message.error(result.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消"
            });
          });
      }
    },
    //获取二级列表（弹窗）
    chooseAddPPid(id, bol) {
      this.api.subjectCourse
        .getSubjectCourseListByPid({
          pid: id
        })
        .then(result => {
          this.addpList = result.data;
          if (bol) {
            //打开修改窗，无需清空二级列表id
            this.editFormVisible = true;
          } else {
            //选择一级列表，需要清空二级列表id
            this.addForm.pid = "";
            this.editForm.pid = "";
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    //获取二级列表
    choosePPid() {
      this.api.subjectCourse
        .getSubjectCourseListByPid({
          pid: this.searchParam.ppid
        })
        .then(result => {
          this.pList = result.data;
          this.searchParam.pid = "";
        })
        .catch(error => {
          console.log(error);
        });
    },
    //获取一级列表
    getTypeLit() {
      this.api.subjectCourse
        .getSubjectCourseListByPid({
          pid: 0
        })
        .then(result => {
          this.ppList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //搜索
    searchList() {
      //将搜索条件加入列表参数中，及再次getlist时，为搜索的条件
      this.param = JSON.parse(JSON.stringify(this.searchParam));
      this.api.subjectCourse
        .getPageList(this.searchParam)
        .then(result => {
          this.list = result.data.records;
          this.returnVal = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //获取三级列表
    getList() {
      this.api.subjectCourse
        .getPageList(this.param)
        .then(result => {
          this.list = result.data.records;
          this.returnVal = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //获取三级详情
    editBtn(id) {
      this.api.subjectCourse.getSubjectCourse({ id: id }).then(res => {
        this.editForm = res.data;
        //根据一级id获取二级列表
        this.chooseAddPPid(res.data.ppid, true);
      });
    },
    submitEdit() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.api.subjectCourse
            .updateSubjectCourse(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  message: "恭喜你，操作成功",
                  type: "success"
                });
                this.editFormVisible = false;
                this.getList();
              } else {
                this.$message.error("操作失败，请重试");
              }
            })
            .catch(error => {
              console.log(error);
            });
        }
      });
    },
    submitAdd() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          console.log(this.addForm);
          var param = this.addForm;
          if (this.addForm.state) {
            param.state = 1;
          } else {
            param.state = -1;
          }
          this.api.subjectCourse
            .addSubjectCourse(param)
            .then(result => {
              if (result.success) {
                this.$message({
                  message: "恭喜你，操作成功",
                  type: "success"
                });
                this.addFormVisible = false;
                this.getList();
              } else {
                this.$message.error("操作失败，请重试");
              }
            })
            .catch(error => {
              console.log(error);
            });
        }
      });
    },
    //重置表格
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },

  watch: {
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
      } else {
      }
    }
  },
  mounted() {
    this.getTypeLit(); //获取一级列表
    this.getList(); //获取三级列表
  }
};
</script>


// WEBPACK FOOTER //
// src/components/subject/subjectCourse.vue